var items = {
  "block.minecraft.air": "lufd",
  "block.minecraft.stone": "schdeen",
  "block.minecraft.granite": "granid",
  "block.minecraft.polished_granite": "bolierdorr granid",
  "block.minecraft.diorite": "diorid",
  "block.minecraft.polished_diorite": "bolierdorr diorid",
  "block.minecraft.andesite": "andesid",
  "block.minecraft.polished_andesite": "bolierdorr andesid",
  "block.minecraft.grass_block": "grasblogg",
  "block.minecraft.dirt": "ährde",
  "block.minecraft.coarse_dirt": "grobe ährde",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "garmesin-nädsl",
  "block.minecraft.warped_nylium": "würr-nädsl",
  "block.minecraft.cobblestone": "bruchschdeen",
  "block.minecraft.oak_planks": "eischnhulzbreddor",
  "block.minecraft.spruce_planks": "fischdnhulzbreddor",
  "block.minecraft.birch_planks": "bürschnhulzbreddor",
  "block.minecraft.jungle_planks": "drobnhulzbreddor",
  "block.minecraft.acacia_planks": "agazienhulzbreddor",
  "block.minecraft.dark_oak_planks": "schworzeischnhulzbreddor",
  "block.minecraft.crimson_planks": "garmesinbreddor",
  "block.minecraft.warped_planks": "würrbreddor",
  "block.minecraft.oak_sapling": "eischnseddsling",
  "block.minecraft.spruce_sapling": "fischdnseddsling",
  "block.minecraft.birch_sapling": "bürschnseddsling",
  "block.minecraft.jungle_sapling": "drobnbohmseddsling",
  "block.minecraft.acacia_sapling": "agazienseddsling",
  "block.minecraft.dark_oak_sapling": "schworzeischnseddsling",
  "block.minecraft.bedrock": "grundgeschdeen",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "rodorr sand",
  "block.minecraft.gravel": "gies",
  "block.minecraft.gold_ore": "goldärds",
  "block.minecraft.iron_ore": "eisnärds",
  "block.minecraft.coal_ore": "schdeengohle",
  "block.minecraft.nether_gold_ore": "nethergoldärds",
  "block.minecraft.oak_log": "eischnschdamm",
  "block.minecraft.spruce_log": "fischdnschdamm",
  "block.minecraft.birch_log": "bürschnschdamm",
  "block.minecraft.jungle_log": "drobnbohmschdamm",
  "block.minecraft.acacia_log": "agazienschdamm",
  "block.minecraft.dark_oak_log": "schworzeischnschdamm",
  "block.minecraft.crimson_stem": "garmesinschdiel",
  "block.minecraft.warped_stem": "würrschdiel",
  "block.minecraft.stripped_oak_log": "endrindedorr eischnschdamm",
  "block.minecraft.stripped_spruce_log": "endrindedorr fischdnschdamm",
  "block.minecraft.stripped_birch_log": "endrindedorr bürschnschdamm",
  "block.minecraft.stripped_jungle_log": "endrindedorr drobnbohmschdamm",
  "block.minecraft.stripped_acacia_log": "endrindedorr agazienschdamm",
  "block.minecraft.stripped_dark_oak_log": "endrindedorr schworzeischnschdamm",
  "block.minecraft.stripped_crimson_stem": "geschäldorr garmesinschdiel",
  "block.minecraft.stripped_warped_stem": "geschäldorr würrschdiel",
  "block.minecraft.stripped_oak_wood": "endrindedes eischnhulz",
  "block.minecraft.stripped_spruce_wood": "endrindedes fischdnhulz",
  "block.minecraft.stripped_birch_wood": "endrindedes bürschnhulz",
  "block.minecraft.stripped_jungle_wood": "endrindedes drobnhulz",
  "block.minecraft.stripped_acacia_wood": "endrindedes agazienhulz",
  "block.minecraft.stripped_dark_oak_wood": "endrindedes schworzeischnhulz",
  "block.minecraft.stripped_crimson_hyphae": "geschälde garmesinhyphn",
  "block.minecraft.stripped_warped_hyphae": "geschälde würrhyphn",
  "block.minecraft.oak_wood": "eischnhulz",
  "block.minecraft.spruce_wood": "fischdnhulz",
  "block.minecraft.birch_wood": "bürschnhulz",
  "block.minecraft.jungle_wood": "drobnhulz",
  "block.minecraft.acacia_wood": "agazienhulz",
  "block.minecraft.dark_oak_wood": "schworzeischnhulz",
  "block.minecraft.crimson_hyphae": "garmesinhyphn",
  "block.minecraft.warped_hyphae": "würrhyphn",
  "block.minecraft.oak_leaves": "eischnlaub",
  "block.minecraft.spruce_leaves": "fischdnnadln",
  "block.minecraft.birch_leaves": "bürschnlaub",
  "block.minecraft.jungle_leaves": "drobnbohmlaub",
  "block.minecraft.acacia_leaves": "agazienlaub",
  "block.minecraft.dark_oak_leaves": "schworzeischnlaub",
  "block.minecraft.sponge": "schwamm",
  "block.minecraft.wet_sponge": "nassorr schwamm",
  "block.minecraft.glass": "glas",
  "block.minecraft.lapis_ore": "labisladsuliärds",
  "block.minecraft.lapis_block": "labisladsuliblogg",
  "block.minecraft.dispenser": "werforr",
  "block.minecraft.sandstone": "sandschdeen",
  "block.minecraft.chiseled_sandstone": "gemeißeldorr sandschdeen",
  "block.minecraft.cut_sandstone": "geschniddnorr sandschdeen",
  "block.minecraft.note_block": "noodnblogg",
  "block.minecraft.powered_rail": "andriebsschiene",
  "block.minecraft.detector_rail": "sensorschiene",
  "block.minecraft.sticky_piston": "gläbrigorr golbn",
  "block.minecraft.cobweb": "schbinnnädds",
  "block.minecraft.grass": "gras",
  "block.minecraft.fern": "farn",
  "block.minecraft.dead_bush": "dodorr busch",
  "block.minecraft.seagrass": "seegras",
  "block.minecraft.sea_pickle": "seegurge",
  "block.minecraft.piston": "golbn",
  "block.minecraft.white_wool": "weeße wolle",
  "block.minecraft.orange_wool": "orangsche wolle",
  "block.minecraft.magenta_wool": "magenda wolle",
  "block.minecraft.light_blue_wool": "hellblaue wolle",
  "block.minecraft.yellow_wool": "gelbe wolle",
  "block.minecraft.lime_wool": "hellgriene wolle",
  "block.minecraft.pink_wool": "pinge wolle",
  "block.minecraft.gray_wool": "graue wolle",
  "block.minecraft.light_gray_wool": "hellgraue wolle",
  "block.minecraft.cyan_wool": "dürgise wolle",
  "block.minecraft.purple_wool": "lila wolle",
  "block.minecraft.blue_wool": "blaue wolle",
  "block.minecraft.brown_wool": "braune wolle",
  "block.minecraft.green_wool": "griene wolle",
  "block.minecraft.red_wool": "rode wolle",
  "block.minecraft.black_wool": "schworze wolle",
  "block.minecraft.dandelion": "leewnzohn",
  "block.minecraft.poppy": "mohn",
  "block.minecraft.blue_orchid": "blaue orchidee",
  "block.minecraft.allium": "schdernlauch",
  "block.minecraft.azure_bluet": "porzellanschdernschn",
  "block.minecraft.red_tulip": "rode dulbe",
  "block.minecraft.orange_tulip": "orangsche dulbe",
  "block.minecraft.white_tulip": "weeße dulbe",
  "block.minecraft.pink_tulip": "pinge dulbe",
  "block.minecraft.oxeye_daisy": "margoride",
  "block.minecraft.cornflower": "gornblume",
  "block.minecraft.lily_of_the_valley": "maiglöggschn",
  "block.minecraft.wither_rose": "wither-rose",
  "block.minecraft.brown_mushroom": "braunorr bilz",
  "block.minecraft.red_mushroom": "rodorr bilz",
  "block.minecraft.crimson_fungus": "garmesinbilz",
  "block.minecraft.warped_fungus": "würrbilz",
  "block.minecraft.crimson_roots": "garmesinwurdsln",
  "block.minecraft.warped_roots": "würrwurdsln",
  "block.minecraft.nether_sprouts": "netherschbrossn",
  "block.minecraft.weeping_vines": "drauorrrangn",
  "block.minecraft.twisting_vines": "zwürblrangn",
  "block.minecraft.sugar_cane": "zuggorrrohr",
  "block.minecraft.kelp": "seedang",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "goldblogg",
  "block.minecraft.iron_block": "eisnblogg",
  "block.minecraft.oak_slab": "eischnhulzschdufe",
  "block.minecraft.spruce_slab": "fischdnhulzschdufe",
  "block.minecraft.birch_slab": "bürschnhulzschdufe",
  "block.minecraft.jungle_slab": "drobnhulzschdufe",
  "block.minecraft.acacia_slab": "agazienhulzschdufe",
  "block.minecraft.dark_oak_slab": "schworzeischnhulzschdufe",
  "block.minecraft.crimson_slab": "garmesinschdufe",
  "block.minecraft.warped_slab": "würrschdufe",
  "block.minecraft.stone_slab": "schdeenschdufe",
  "block.minecraft.smooth_stone_slab": "gladde schdeenschdufe",
  "block.minecraft.sandstone_slab": "sandschdeenschdufe",
  "block.minecraft.cut_sandstone_slab": "geschniddne sandschdeenschdufe",
  "block.minecraft.petrified_oak_slab": "vorschdeinorde eischnhulzschdufe",
  "block.minecraft.cobblestone_slab": "bruchschdeenschdufe",
  "block.minecraft.brick_slab": "zieschlschdufe",
  "block.minecraft.stone_brick_slab": "schdeenzieschlschdufe",
  "block.minecraft.nether_brick_slab": "netherzieschlschdufe",
  "block.minecraft.quartz_slab": "quarzschdufe",
  "block.minecraft.red_sandstone_slab": "rode sandschdeenschdufe",
  "block.minecraft.cut_red_sandstone_slab": "geschniddne rode sandschdeenschdufe",
  "block.minecraft.purpur_slab": "purpurschdufe",
  "block.minecraft.prismarine_slab": "brismarinschdufe",
  "block.minecraft.prismarine_brick_slab": "brismarinzieschlschdufe",
  "block.minecraft.dark_prismarine_slab": "dungle brismarinschdufe",
  "block.minecraft.smooth_quartz": "gladdorr quarzblogg",
  "block.minecraft.smooth_red_sandstone": "gladdorr rodorr sandschdeen",
  "block.minecraft.smooth_sandstone": "gladdorr sandschdeen",
  "block.minecraft.smooth_stone": "gladdorr schdeen",
  "block.minecraft.bricks": "zieschl",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "schwahrdnregal",
  "block.minecraft.mossy_cobblestone": "bemoosdorr bruchschdeen",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "faggl",
  "block.minecraft.end_rod": "endschdab",
  "block.minecraft.chorus_plant": "choruspflanze",
  "block.minecraft.chorus_flower": "chorusblüde",
  "block.minecraft.purpur_block": "purpurblogg",
  "block.minecraft.purpur_pillar": "purpursäule",
  "block.minecraft.purpur_stairs": "purpurdrebbe",
  "block.minecraft.spawner": "schbornorr",
  "block.minecraft.oak_stairs": "eischenhulzdrebbe",
  "block.minecraft.chest": "druhe",
  "block.minecraft.diamond_ore": "diamandärds",
  "block.minecraft.diamond_block": "diamandblogg",
  "block.minecraft.crafting_table": "wergbang",
  "block.minecraft.farmland": "aggorbodn",
  "block.minecraft.furnace": "ofn",
  "block.minecraft.ladder": "leidorr",
  "block.minecraft.rail": "schiene",
  "block.minecraft.cobblestone_stairs": "bruchschdeendrebbe",
  "block.minecraft.lever": "hebl",
  "block.minecraft.stone_pressure_plate": "schdeendruggbladde",
  "block.minecraft.oak_pressure_plate": "eischnhulzdruggbladde",
  "block.minecraft.spruce_pressure_plate": "fischdnhulzdruggbladde",
  "block.minecraft.birch_pressure_plate": "bürschnhulzdruggbladde",
  "block.minecraft.jungle_pressure_plate": "drobnhulzdruggbladde",
  "block.minecraft.acacia_pressure_plate": "agazienhulzdruggbladde",
  "block.minecraft.dark_oak_pressure_plate": "schworzeischnhulzdruggbladde",
  "block.minecraft.crimson_pressure_plate": "garmesindruggbladde",
  "block.minecraft.warped_pressure_plate": "würrdruggbladde",
  "block.minecraft.polished_blackstone_pressure_plate": "bolierde schworzschdeendruggbladde",
  "block.minecraft.redstone_ore": "redstone-ärds",
  "block.minecraft.redstone_torch": "redstone-faggl",
  "block.minecraft.snow": "schnee",
  "block.minecraft.ice": "eis",
  "block.minecraft.snow_block": "schneeblogg",
  "block.minecraft.cactus": "gaggdus",
  "block.minecraft.clay": "don",
  "block.minecraft.jukebox": "bladdnschbielorr",
  "block.minecraft.oak_fence": "eischnhulzzaun",
  "block.minecraft.spruce_fence": "fischdnhulzzaun",
  "block.minecraft.birch_fence": "bürschnhulzzaun",
  "block.minecraft.jungle_fence": "drobnhulzzaun",
  "block.minecraft.acacia_fence": "agazienhulzzaun",
  "block.minecraft.dark_oak_fence": "schworzeischnhulzzaun",
  "block.minecraft.crimson_fence": "garmesinzaun",
  "block.minecraft.warped_fence": "würrzaun",
  "block.minecraft.pumpkin": "gürbis",
  "block.minecraft.carved_pumpkin": "geschnidzdorr gürbis",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "seelnsand",
  "block.minecraft.soul_soil": "seelnerde",
  "block.minecraft.basalt": "basald",
  "block.minecraft.polished_basalt": "bolierdorr basald",
  "block.minecraft.soul_torch": "seelnfaggl",
  "block.minecraft.glowstone": "glowstone",
  "block.minecraft.jack_o_lantern": "gürbisladderne",
  "block.minecraft.oak_trapdoor": "eischnhulzfalldiere",
  "block.minecraft.spruce_trapdoor": "fischdnhulzfalldiere",
  "block.minecraft.birch_trapdoor": "bürschnhulzfalldiere",
  "block.minecraft.jungle_trapdoor": "drobnhulzfalldiere",
  "block.minecraft.acacia_trapdoor": "agazienhulzfalldiere",
  "block.minecraft.dark_oak_trapdoor": "schworzeischnhulzfalldiere",
  "block.minecraft.crimson_trapdoor": "garmesinfalldiere",
  "block.minecraft.warped_trapdoor": "würrfalldiere",
  "block.minecraft.infested_stone": "befallnorr schdeen",
  "block.minecraft.infested_cobblestone": "befallnorr bruchschdeen",
  "block.minecraft.infested_stone_bricks": "befallne schdeenzieschl",
  "block.minecraft.infested_mossy_stone_bricks": "befallne bemoosde schdeenzieschl",
  "block.minecraft.infested_cracked_stone_bricks": "befallnorr riss'schorr schdeenzieschl",
  "block.minecraft.infested_chiseled_stone_bricks": "befallne gemeißelde schdeenzieschl",
  "block.minecraft.stone_bricks": "schdeenzieschl",
  "block.minecraft.mossy_stone_bricks": "bemoosde schdeenzieschl",
  "block.minecraft.cracked_stone_bricks": "riss'sche schdeenzieschl",
  "block.minecraft.chiseled_stone_bricks": "gemeißeldorr schdeenzieschl",
  "block.minecraft.brown_mushroom_block": "braunorr bilzblogg",
  "block.minecraft.red_mushroom_block": "rodorr bilzblogg",
  "block.minecraft.mushroom_stem": "bilzschdiel",
  "block.minecraft.iron_bars": "eisngiddor",
  "block.minecraft.chain": "kedde",
  "block.minecraft.glass_pane": "glasscheebe",
  "block.minecraft.melon": "melone",
  "block.minecraft.vine": "rangn",
  "block.minecraft.oak_fence_gate": "eischnhulzzaundorr",
  "block.minecraft.spruce_fence_gate": "fischdnhulzzaundorr",
  "block.minecraft.birch_fence_gate": "bürschnhulzzaundorr",
  "block.minecraft.jungle_fence_gate": "drobnhulzzaundorr",
  "block.minecraft.acacia_fence_gate": "agazienhulzzaundorr",
  "block.minecraft.dark_oak_fence_gate": "schworzeischnhulzzaundorr",
  "block.minecraft.crimson_fence_gate": "garmesinzaundorr",
  "block.minecraft.warped_fence_gate": "würrzaundorr",
  "block.minecraft.brick_stairs": "zieschldrebbe",
  "block.minecraft.stone_brick_stairs": "schdeenzieschldrebbe",
  "block.minecraft.mycelium": "mydsäl",
  "block.minecraft.lily_pad": "seerosnbladd",
  "block.minecraft.nether_bricks": "netherzieschl",
  "block.minecraft.cracked_nether_bricks": "riss'sche netherzieschl",
  "block.minecraft.chiseled_nether_bricks": "gemeißelde netherzieschl",
  "block.minecraft.nether_brick_fence": "netherzieschlzaun",
  "block.minecraft.nether_brick_stairs": "netherzieschldrebbe",
  "block.minecraft.enchanting_table": "zaubordisch",
  "block.minecraft.end_portal_frame": "endbordalrahm",
  "block.minecraft.end_stone": "endschdeen",
  "block.minecraft.end_stone_bricks": "endschdeenzieschl",
  "block.minecraft.dragon_egg": "drachnei",
  "block.minecraft.redstone_lamp": "redstone-funsl",
  "block.minecraft.sandstone_stairs": "sandschdeendrebbe",
  "block.minecraft.emerald_ore": "smaragdärds",
  "block.minecraft.ender_chest": "enderdruhe",
  "block.minecraft.tripwire_hook": "hagn",
  "block.minecraft.emerald_block": "smaragdblogg",
  "block.minecraft.spruce_stairs": "fischdnhulzdrebbe",
  "block.minecraft.birch_stairs": "bürschnhulzdrebbe",
  "block.minecraft.jungle_stairs": "drobnhulzdrebbe",
  "block.minecraft.crimson_stairs": "garmesindrebbe",
  "block.minecraft.warped_stairs": "würrdrebbe",
  "block.minecraft.command_block": "befählsblogg",
  "block.minecraft.beacon": "leuschdfeuorr",
  "block.minecraft.cobblestone_wall": "bruchschdeenmauor",
  "block.minecraft.mossy_cobblestone_wall": "bemoosde bruchschdeenmauor",
  "block.minecraft.brick_wall": "zieschlschdeenmauor",
  "block.minecraft.prismarine_wall": "brismarinmauor",
  "block.minecraft.red_sandstone_wall": "rodde sandschdeenmauor",
  "block.minecraft.mossy_stone_brick_wall": "bemoosde schdeenzieschlmauor",
  "block.minecraft.granite_wall": "granidmauor",
  "block.minecraft.stone_brick_wall": "schdeenzieschlmauor",
  "block.minecraft.nether_brick_wall": "netherzieschlmauor",
  "block.minecraft.andesite_wall": "andesidmauor",
  "block.minecraft.red_nether_brick_wall": "rode netherzieschlmauor",
  "block.minecraft.sandstone_wall": "sandschdeenmauor",
  "block.minecraft.end_stone_brick_wall": "endschdeenzieschlmauor",
  "block.minecraft.diorite_wall": "dioridmauor",
  "block.minecraft.blackstone_wall": "schworzschdeenmauor",
  "block.minecraft.polished_blackstone_wall": "bolierde schworzschdeenmauor",
  "block.minecraft.polished_blackstone_brick_wall": "bolierde schworzschdeenzieschlmauor",
  "block.minecraft.stone_button": "schdeengnopp",
  "block.minecraft.oak_button": "eischnhulzgnopp",
  "block.minecraft.spruce_button": "fischdnhulzgnopp",
  "block.minecraft.birch_button": "bürschnhulzgnopp",
  "block.minecraft.jungle_button": "drobnhulzgnopp",
  "block.minecraft.acacia_button": "agazienhulzgnopp",
  "block.minecraft.dark_oak_button": "schworzeischnhulzgnopp",
  "block.minecraft.crimson_button": "garmesingnopp",
  "block.minecraft.warped_button": "würrgnopp",
  "block.minecraft.polished_blackstone_button": "bolierdorr schworzschdeengnopp",
  "block.minecraft.anvil": "amboss",
  "block.minecraft.chipped_anvil": "angeschlachnorr amboss",
  "block.minecraft.damaged_anvil": "beschädigdorr amboss",
  "block.minecraft.trapped_chest": "redstone-druhe",
  "block.minecraft.light_weighted_pressure_plate": "feinwäschebladde",
  "block.minecraft.heavy_weighted_pressure_plate": "grobwäschebladde",
  "block.minecraft.daylight_detector": "daacheslischdsensor",
  "block.minecraft.redstone_block": "redstone-blogg",
  "block.minecraft.nether_quartz_ore": "netherquarzärds",
  "block.minecraft.hopper": "drischdor",
  "block.minecraft.chiseled_quartz_block": "gemeißeldorr quarzblogg",
  "block.minecraft.quartz_block": "quarzblogg",
  "block.minecraft.quartz_bricks": "quarzzieschl",
  "block.minecraft.quartz_pillar": "quarzsäule",
  "block.minecraft.quartz_stairs": "quarzdrebbe",
  "block.minecraft.activator_rail": "aggdivierungsschiene",
  "block.minecraft.dropper": "schbendor",
  "block.minecraft.white_terracotta": "weeße geramigg",
  "block.minecraft.orange_terracotta": "orangschne geramigg",
  "block.minecraft.magenta_terracotta": "magenda geramigg",
  "block.minecraft.light_blue_terracotta": "hellblaue geramigg",
  "block.minecraft.yellow_terracotta": "gelbe geramigg",
  "block.minecraft.lime_terracotta": "hellgriene geramigg",
  "block.minecraft.pink_terracotta": "pinge geramigg",
  "block.minecraft.gray_terracotta": "graue geramigg",
  "block.minecraft.light_gray_terracotta": "hellgraue geramigg",
  "block.minecraft.cyan_terracotta": "dürgise geramigg",
  "block.minecraft.purple_terracotta": "lila geramigg",
  "block.minecraft.blue_terracotta": "blaue geramigg",
  "block.minecraft.brown_terracotta": "braune geramigg",
  "block.minecraft.green_terracotta": "griene geramigg",
  "block.minecraft.red_terracotta": "rode geramigg",
  "block.minecraft.black_terracotta": "schworze geramigg",
  "block.minecraft.barrier": "barriere",
  "block.minecraft.iron_trapdoor": "eisnfalldiere",
  "block.minecraft.hay_block": "schdrohballn",
  "block.minecraft.white_carpet": "weeßorr täppsch",
  "block.minecraft.orange_carpet": "orangschnorr täppsch",
  "block.minecraft.magenta_carpet": "magenda täppsch",
  "block.minecraft.light_blue_carpet": "hellblauorr täppsch",
  "block.minecraft.yellow_carpet": "gelborr täppsch",
  "block.minecraft.lime_carpet": "hellgrienorr täppsch",
  "block.minecraft.pink_carpet": "rosa täppsch",
  "block.minecraft.gray_carpet": "grauorr täppsch",
  "block.minecraft.light_gray_carpet": "hellgrauorr täppsch",
  "block.minecraft.cyan_carpet": "dürgisorr täppsch",
  "block.minecraft.purple_carpet": "lila täppsch",
  "block.minecraft.blue_carpet": "blauorr täppsch",
  "block.minecraft.brown_carpet": "braunorr täppsch",
  "block.minecraft.green_carpet": "grünorr täppsch",
  "block.minecraft.red_carpet": "rodorr täppsch",
  "block.minecraft.black_carpet": "schwarzorr täppsch",
  "block.minecraft.terracotta": "geramigg",
  "block.minecraft.coal_block": "gohleblogg",
  "block.minecraft.packed_ice": "paggeis",
  "block.minecraft.acacia_stairs": "agazienhulzdrebbe",
  "block.minecraft.dark_oak_stairs": "schworzeischnhulzdrebbe",
  "block.minecraft.slime_block": "schleimblogg",
  "block.minecraft.grass_path": "dramblpfad",
  "block.minecraft.sunflower": "sonnenblume",
  "block.minecraft.lilac": "fliedor",
  "block.minecraft.rose_bush": "rosnschdrauch",
  "block.minecraft.peony": "pfingsdrose",
  "block.minecraft.tall_grass": "hohes gras",
  "block.minecraft.large_fern": "großorr farn",
  "block.minecraft.white_stained_glass": "weeßes glas",
  "block.minecraft.orange_stained_glass": "orangsches glas",
  "block.minecraft.magenta_stained_glass": "magenda glas",
  "block.minecraft.light_blue_stained_glass": "hellblaues glas",
  "block.minecraft.yellow_stained_glass": "gelbes glas",
  "block.minecraft.lime_stained_glass": "hellgrienes glas",
  "block.minecraft.pink_stained_glass": "pinges glas",
  "block.minecraft.gray_stained_glass": "graues glas",
  "block.minecraft.light_gray_stained_glass": "hellgraues glas",
  "block.minecraft.cyan_stained_glass": "dürgises glas",
  "block.minecraft.purple_stained_glass": "lila glas",
  "block.minecraft.blue_stained_glass": "blaues glas",
  "block.minecraft.brown_stained_glass": "braunes glas",
  "block.minecraft.green_stained_glass": "grienes glas",
  "block.minecraft.red_stained_glass": "rodes glas",
  "block.minecraft.black_stained_glass": "schworzes glas",
  "block.minecraft.white_stained_glass_pane": "weeße glasscheebe",
  "block.minecraft.orange_stained_glass_pane": "orangsche glasscheebe",
  "block.minecraft.magenta_stained_glass_pane": "magenda glasscheebe",
  "block.minecraft.light_blue_stained_glass_pane": "hellblaue glasscheebe",
  "block.minecraft.yellow_stained_glass_pane": "gelbe glasscheebe",
  "block.minecraft.lime_stained_glass_pane": "hellgriene glasscheebe",
  "block.minecraft.pink_stained_glass_pane": "pinge glasscheebe",
  "block.minecraft.gray_stained_glass_pane": "graue glasscheebe",
  "block.minecraft.light_gray_stained_glass_pane": "hellgraue glasscheebe",
  "block.minecraft.cyan_stained_glass_pane": "dürgise glasscheebe",
  "block.minecraft.purple_stained_glass_pane": "lila glasscheebe",
  "block.minecraft.blue_stained_glass_pane": "blaue glasscheebe",
  "block.minecraft.brown_stained_glass_pane": "braune glasscheebe",
  "block.minecraft.green_stained_glass_pane": "griene glasscheebe",
  "block.minecraft.red_stained_glass_pane": "rode glasscheebe",
  "block.minecraft.black_stained_glass_pane": "schworze glasscheebe",
  "block.minecraft.prismarine": "brismarin",
  "block.minecraft.prismarine_bricks": "brismarinzieschl",
  "block.minecraft.dark_prismarine": "dunglorr brismarin",
  "block.minecraft.prismarine_stairs": "brismarindrebbe",
  "block.minecraft.prismarine_brick_stairs": "brismarinzieschldrebbe",
  "block.minecraft.dark_prismarine_stairs": "dungle brismarindrebbe",
  "block.minecraft.sea_lantern": "seeladderne",
  "block.minecraft.red_sandstone": "rodorr sandschdeen",
  "block.minecraft.chiseled_red_sandstone": "gemeißeldorr rodorr sandschdeen",
  "block.minecraft.cut_red_sandstone": "geschniddnorr rodorr sandschdeen",
  "block.minecraft.red_sandstone_stairs": "rode sandschdeendrebbe",
  "block.minecraft.repeating_command_block": "wiedorrhol-befählsblogg",
  "block.minecraft.chain_command_block": "keddn-befählsblogg",
  "block.minecraft.magma_block": "magmablogg",
  "block.minecraft.nether_wart_block": "netherwarznblogg",
  "block.minecraft.warped_wart_block": "würrwarznblogg",
  "block.minecraft.red_nether_bricks": "rode netherzieschl",
  "block.minecraft.bone_block": "gnochnblogg",
  "block.minecraft.structure_void": "gonsdrugtionsleere",
  "block.minecraft.observer": "beobachdor",
  "block.minecraft.shulker_box": "shulker-gissde",
  "block.minecraft.white_shulker_box": "weeße shulker-gissde",
  "block.minecraft.orange_shulker_box": "orangschne shulker-gissde",
  "block.minecraft.magenta_shulker_box": "magenda shulker-gissde",
  "block.minecraft.light_blue_shulker_box": "hellblaue shulker-gissde",
  "block.minecraft.yellow_shulker_box": "gelbe shulker-gissde",
  "block.minecraft.lime_shulker_box": "hellgriene shulker-gissde",
  "block.minecraft.pink_shulker_box": "pinge shulker-gissde",
  "block.minecraft.gray_shulker_box": "graue shulker-gissde",
  "block.minecraft.light_gray_shulker_box": "hellgraue shulker-gissde",
  "block.minecraft.cyan_shulker_box": "dürgise shulker-gissde",
  "block.minecraft.purple_shulker_box": "lila shulker-gissde",
  "block.minecraft.blue_shulker_box": "blaue shulker-gissde",
  "block.minecraft.brown_shulker_box": "braune shulker-gissde",
  "block.minecraft.green_shulker_box": "griene shulker-gissde",
  "block.minecraft.red_shulker_box": "rode shulker-gissde",
  "block.minecraft.black_shulker_box": "schworze shulker-gissde",
  "block.minecraft.white_glazed_terracotta": "weeße glasierde geramigg",
  "block.minecraft.orange_glazed_terracotta": "orangsche glasierde geramigg",
  "block.minecraft.magenta_glazed_terracotta": "magenda glasierde geramigg",
  "block.minecraft.light_blue_glazed_terracotta": "hellblaue glasierde geramigg",
  "block.minecraft.yellow_glazed_terracotta": "gelbe glasierde geramigg",
  "block.minecraft.lime_glazed_terracotta": "hellgriene glasierde geramigg",
  "block.minecraft.pink_glazed_terracotta": "pinge glasierde geramigg",
  "block.minecraft.gray_glazed_terracotta": "graue glasierde geramigg",
  "block.minecraft.light_gray_glazed_terracotta": "hellgraue glasierde geramigg",
  "block.minecraft.cyan_glazed_terracotta": "dürgise glasierde geramigg",
  "block.minecraft.purple_glazed_terracotta": "lila glasierde geramigg",
  "block.minecraft.blue_glazed_terracotta": "blaue glasierde geramigg",
  "block.minecraft.brown_glazed_terracotta": "braune glasierde geramigg",
  "block.minecraft.green_glazed_terracotta": "griene glasierde geramigg",
  "block.minecraft.red_glazed_terracotta": "rode glasierde geramigg",
  "block.minecraft.black_glazed_terracotta": "schworze glasierde geramigg",
  "block.minecraft.white_concrete": "weeßorr bedong",
  "block.minecraft.orange_concrete": "orangschorr bedong",
  "block.minecraft.magenta_concrete": "magenda bedong",
  "block.minecraft.light_blue_concrete": "hellblauorr bedong",
  "block.minecraft.yellow_concrete": "gelborr bedong",
  "block.minecraft.lime_concrete": "hellgrienorr bedong",
  "block.minecraft.pink_concrete": "pingorr bedong",
  "block.minecraft.gray_concrete": "grauorr bedong",
  "block.minecraft.light_gray_concrete": "hellgrauorr bedong",
  "block.minecraft.cyan_concrete": "dürgisorr bedong",
  "block.minecraft.purple_concrete": "lila bedong",
  "block.minecraft.blue_concrete": "blauorr bedong",
  "block.minecraft.brown_concrete": "braunorr bedong",
  "block.minecraft.green_concrete": "grienorr bedong",
  "block.minecraft.red_concrete": "rodorr bedong",
  "block.minecraft.black_concrete": "schworzorr bedong",
  "block.minecraft.white_concrete_powder": "weeßorr droggnbedong",
  "block.minecraft.orange_concrete_powder": "orangschorr droggnbedong",
  "block.minecraft.magenta_concrete_powder": "magenda droggnbedong",
  "block.minecraft.light_blue_concrete_powder": "hellblauorr droggnbedong",
  "block.minecraft.yellow_concrete_powder": "gelborr droggnbedong",
  "block.minecraft.lime_concrete_powder": "hellgrienorr droggnbedong",
  "block.minecraft.pink_concrete_powder": "pingorr droggnbedong",
  "block.minecraft.gray_concrete_powder": "grauorr droggnbedong",
  "block.minecraft.light_gray_concrete_powder": "hellgrauorr droggnbedong",
  "block.minecraft.cyan_concrete_powder": "dürgisorr droggnbedong",
  "block.minecraft.purple_concrete_powder": "lila droggnbedong",
  "block.minecraft.blue_concrete_powder": "blauorr droggnbedong",
  "block.minecraft.brown_concrete_powder": "braunorr droggnbedong",
  "block.minecraft.green_concrete_powder": "grienorr droggnbedong",
  "block.minecraft.red_concrete_powder": "rodorr droggnbedong",
  "block.minecraft.black_concrete_powder": "schworzorr droggnbedong",
  "block.minecraft.turtle_egg": "schüldgrödnei",
  "block.minecraft.dead_tube_coral_block": "abgeschdorbnorr orschlgorallnblogg",
  "block.minecraft.dead_brain_coral_block": "abgeschdorbnorr hirngorallnblogg",
  "block.minecraft.dead_bubble_coral_block": "abgeschdorbnorr blasngorallnblogg",
  "block.minecraft.dead_fire_coral_block": "abgeschdorbnorr feuorrgorallnblogg",
  "block.minecraft.dead_horn_coral_block": "abgeschdorbnorr geweihgorallnblogg",
  "block.minecraft.tube_coral_block": "orschlgorallnblogg",
  "block.minecraft.brain_coral_block": "hirngorallnblogg",
  "block.minecraft.bubble_coral_block": "blasngorallnblogg",
  "block.minecraft.fire_coral_block": "feuorrgorallnblogg",
  "block.minecraft.horn_coral_block": "geweihgorallnblogg",
  "block.minecraft.tube_coral": "orschlgoralle",
  "block.minecraft.brain_coral": "hirngoralle",
  "block.minecraft.bubble_coral": "blasngoralle",
  "block.minecraft.fire_coral": "feuorrgoralle",
  "block.minecraft.horn_coral": "geweihgoralle",
  "block.minecraft.dead_brain_coral": "abgeschdorbne hirngoralle",
  "block.minecraft.dead_bubble_coral": "abgeschdorbne blasngoralle",
  "block.minecraft.dead_fire_coral": "abgeschdorbne feuorrgoralle",
  "block.minecraft.dead_horn_coral": "abgeschdorbne geweihgoralle",
  "block.minecraft.dead_tube_coral": "abgeschdorbne orschlgoralle",
  "block.minecraft.tube_coral_fan": "orschlgorallnfäschorr",
  "block.minecraft.brain_coral_fan": "hirngorallnfäschorr",
  "block.minecraft.bubble_coral_fan": "blasngorallnfäschorr",
  "block.minecraft.fire_coral_fan": "feuorrgorallnfäschorr",
  "block.minecraft.horn_coral_fan": "geweihgorallnfäschorr",
  "block.minecraft.dead_tube_coral_fan": "abgeschdorbnorr orschlgorallnfäschorr",
  "block.minecraft.dead_brain_coral_fan": "abgeschdorbnorr hirngorallnfäschorr",
  "block.minecraft.dead_bubble_coral_fan": "abgeschdorbnorr blasngorallnfäschorr",
  "block.minecraft.dead_fire_coral_fan": "abgeschdorbnorr feuorrgorallnfäschorr",
  "block.minecraft.dead_horn_coral_fan": "abgeschdorbnorr geweihgorallnfäschorr",
  "block.minecraft.blue_ice": "blaues eis",
  "block.minecraft.conduit": "aquisadorr",
  "block.minecraft.polished_granite_stairs": "bolierde graniddrebbe",
  "block.minecraft.smooth_red_sandstone_stairs": "gladde rodde sandschdeendrebbe",
  "block.minecraft.mossy_stone_brick_stairs": "bemoosde schdeenzieschldrebbe",
  "block.minecraft.polished_diorite_stairs": "bolierde dioriddrebbe",
  "block.minecraft.mossy_cobblestone_stairs": "bemoosde bruchschdeendrebbe",
  "block.minecraft.end_stone_brick_stairs": "endschdeenzieschldrebbe",
  "block.minecraft.stone_stairs": "schdeendrebbe",
  "block.minecraft.smooth_sandstone_stairs": "gladde sandschdeendrebbe",
  "block.minecraft.smooth_quartz_stairs": "gladde quarzdrebbe",
  "block.minecraft.granite_stairs": "graniddrebbe",
  "block.minecraft.andesite_stairs": "andesiddrebbe",
  "block.minecraft.red_nether_brick_stairs": "rode netherzieschltrebbe",
  "block.minecraft.polished_andesite_stairs": "bolierde andesiddrebbe",
  "block.minecraft.diorite_stairs": "dioriddrebbe",
  "block.minecraft.polished_granite_slab": "bolierde granidschdufe",
  "block.minecraft.smooth_red_sandstone_slab": "gladde rodde sandschdeenschdufe",
  "block.minecraft.mossy_stone_brick_slab": "bemoosde schdeenzieschlschdufe",
  "block.minecraft.polished_diorite_slab": "bolierde dioridschdufe",
  "block.minecraft.mossy_cobblestone_slab": "bemoosde bruchschdeenschdufe",
  "block.minecraft.end_stone_brick_slab": "endschdeenzieschlschdufe",
  "block.minecraft.smooth_sandstone_slab": "gladde sandschdeenschdufe",
  "block.minecraft.smooth_quartz_slab": "gladde quarzschdufe",
  "block.minecraft.granite_slab": "granidschdufe",
  "block.minecraft.andesite_slab": "andesidschdufe",
  "block.minecraft.red_nether_brick_slab": "rode netherzieschlschdufe",
  "block.minecraft.polished_andesite_slab": "bolierde andesidschdufe",
  "block.minecraft.diorite_slab": "dioridschdufe",
  "block.minecraft.scaffolding": "gerüschd",
  "block.minecraft.iron_door": "eisndiere",
  "block.minecraft.oak_door": "eischnhulzdiere",
  "block.minecraft.spruce_door": "fischdnhulzdiere",
  "block.minecraft.birch_door": "bürschnhulzdiere",
  "block.minecraft.jungle_door": "drobnhulzdiere",
  "block.minecraft.acacia_door": "agazienhulzdiere",
  "block.minecraft.dark_oak_door": "schworzeischnhulzdiere",
  "block.minecraft.crimson_door": "garmesindiere",
  "block.minecraft.warped_door": "würrdiere",
  "block.minecraft.repeater": "redstone-vorschdärgor",
  "block.minecraft.comparator": "redstone-gombaradorr",
  "block.minecraft.structure_block": "gonsdrugtionsblogg",
  "block.minecraft.jigsaw": "vorrbundblogg",
  "item.minecraft.turtle_helmet": "schüldgrödnbanzor□□uff'm kopp:□+ 2 rüsdung",
  "item.minecraft.scute": "hornschüld",
  "item.minecraft.iron_shovel": "eisnschibbe□□in dorr haubdhand:□+ 3.5 angriffsschadn□-3 angriffsgeschwindischkeed",
  "item.minecraft.iron_pickaxe": "eisnschbiddshagge□□in dorr haubdhand:□+ 3 angriffsschadn□-2.8 angriffsgeschwindischkeed",
  "item.minecraft.iron_axe": "eisnaggsd□□in dorr haubdhand:□+ 8 angriffsschadn□-3.1 angriffsgeschwindischkeed",
  "item.minecraft.flint_and_steel": "feuorrzeusch",
  "item.minecraft.apple": "abbl",
  "item.minecraft.bow": "bouchn",
  "item.minecraft.arrow": "pfeil",
  "item.minecraft.coal": "gohle",
  "item.minecraft.charcoal": "hulzgohle",
  "item.minecraft.diamond": "diamand",
  "item.minecraft.iron_ingot": "eisnbarrn",
  "item.minecraft.gold_ingot": "goldbarrn",
  "item.minecraft.netherite_ingot": "nädderidbarrn",
  "item.minecraft.netherite_scrap": "nädderidschdügge",
  "item.minecraft.iron_sword": "eisnschwerd□□in dorr haubdhand:□+ 5 angriffsschadn□-2.4 angriffsgeschwindischkeed",
  "item.minecraft.wooden_sword": "hulzschwerd□□in dorr haubdhand:□+ 3 angriffsschadn□-2.4 angriffsgeschwindischkeed",
  "item.minecraft.wooden_shovel": "hulzschibbe□□in dorr haubdhand:□+ 1.5 angriffsschadn□-3 angriffsgeschwindischkeed",
  "item.minecraft.wooden_pickaxe": "hulzschbiddshagge□□in dorr haubdhand:□+ 1 angriffsschadn□-2.8 angriffsgeschwindischkeed",
  "item.minecraft.wooden_axe": "hulzaggsd□□in dorr haubdhand:□+ 6 angriffsschadn□-3.2 angriffsgeschwindischkeed",
  "item.minecraft.stone_sword": "schdeenschwerd□□in dorr haubdhand:□+ 4 angriffsschadn□-2.4 angriffsgeschwindischkeed",
  "item.minecraft.stone_shovel": "schdeenschibbe□□in dorr haubdhand:□+ 2.5 angriffsschadn□-3 angriffsgeschwindischkeed",
  "item.minecraft.stone_pickaxe": "schdeenschbiddshagge□□in dorr haubdhand:□+ 2 angriffsschadn□-2.8 angriffsgeschwindischkeed",
  "item.minecraft.stone_axe": "schdeenaggsd□□in dorr haubdhand:□+ 8 angriffsschadn□-3.2 angriffsgeschwindischkeed",
  "item.minecraft.diamond_sword": "diamandschwerd□□in dorr haubdhand:□+ 6 angriffsschadn□-2.4 angriffsgeschwindischkeed",
  "item.minecraft.diamond_shovel": "diamandschibbe□□in dorr haubdhand:□+ 4.5 angriffsschadn□-3 angriffsgeschwindischkeed",
  "item.minecraft.diamond_pickaxe": "diamandschbiddshagge□□in dorr haubdhand:□+ 4 angriffsschadn□-2.8 angriffsgeschwindischkeed",
  "item.minecraft.diamond_axe": "diamandaggsd□□in dorr haubdhand:□+ 8 angriffsschadn□-3 angriffsgeschwindischkeed",
  "item.minecraft.stick": "schdogg",
  "item.minecraft.bowl": "schüssl",
  "item.minecraft.mushroom_stew": "bilzsubbe",
  "item.minecraft.golden_sword": "goldschwerd□□in dorr haubdhand:□+ 3 angriffsschadn□-2.4 angriffsgeschwindischkeed",
  "item.minecraft.golden_shovel": "goldschibbe□□in dorr haubdhand:□+ 1.5 angriffsschadn□-3 angriffsgeschwindischkeed",
  "item.minecraft.golden_pickaxe": "goldschbiddshagge□□in dorr haubdhand:□+ 1 angriffsschadn□-2.8 angriffsgeschwindischkeed",
  "item.minecraft.golden_axe": "goldaggsd□□in dorr haubdhand:□+ 6 angriffsschadn□-3 angriffsgeschwindischkeed",
  "item.minecraft.netherite_sword": "nädderidschwerd□□in dorr haubdhand:□+ 7 angriffsschadn□-2.4 angriffsgeschwindischkeed",
  "item.minecraft.netherite_shovel": "nädderidschaufl□□in dorr haubdhand:□+ 5.5 angriffsschadn□-3 angriffsgeschwindischkeed",
  "item.minecraft.netherite_pickaxe": "nädderidschbiddshagge□□in dorr haubdhand:□+ 5 angriffsschadn□-2.8 angriffsgeschwindischkeed",
  "item.minecraft.netherite_axe": "nädderidaggsd□□in dorr haubdhand:□+ 9 angriffsschadn□-3 angriffsgeschwindischkeed",
  "item.minecraft.string": "foadn",
  "item.minecraft.feather": "fädorr",
  "item.minecraft.gunpowder": "schworzbulvorr",
  "item.minecraft.wooden_hoe": "hulzhagge□□in dorr haubdhand:□-3 angriffsgeschwindischkeed",
  "item.minecraft.stone_hoe": "schdeenhagge□□in dorr haubdhand:□-2 angriffsgeschwindischkeed",
  "item.minecraft.iron_hoe": "eisnhagge□□in dorr haubdhand:□-1 angriffsgeschwindischkeed",
  "item.minecraft.diamond_hoe": "diamandhagge□□in dorr haubdhand:",
  "item.minecraft.golden_hoe": "goldhagge□□in dorr haubdhand:□-3 angriffsgeschwindischkeed",
  "item.minecraft.netherite_hoe": "nädderidhagge□□in dorr haubdhand:",
  "item.minecraft.wheat_seeds": "weidsngörnor",
  "item.minecraft.wheat": "weidsn",
  "item.minecraft.bread": "broud",
  "item.minecraft.leather_helmet": "lädormiddse□□uff'm kopp:□+ 1 rüsdung",
  "item.minecraft.leather_chestplate": "lädorjagge□□am görborr:□+ 3 rüsdung",
  "item.minecraft.leather_leggings": "lädorhose□□an d'n beenen:□+ 2 rüsdung",
  "item.minecraft.leather_boots": "lädorlaadschn□□an den füßn:□+ 1 rüsdung",
  "item.minecraft.chainmail_helmet": "keddnhaube□□uff'm kopp:□+ 2 rüsdung",
  "item.minecraft.chainmail_chestplate": "keddnhemde□□am görborr:□+ 5 rüsdung",
  "item.minecraft.chainmail_leggings": "keddnhose□□an d'n beenen:□+ 4 rüsdung",
  "item.minecraft.chainmail_boots": "keddnlaadschn□□an den füßn:□+ 1 rüsdung",
  "item.minecraft.iron_helmet": "eisnhälm□□uff'm kopp:□+ 2 rüsdung",
  "item.minecraft.iron_chestplate": "eisnharnüsch□□am görborr:□+ 6 rüsdung",
  "item.minecraft.iron_leggings": "eisnbeenschudds□□an d'n beenen:□+ 5 rüsdung",
  "item.minecraft.iron_boots": "eisnlaadschn□□an den füßn:□+ 2 rüsdung",
  "item.minecraft.diamond_helmet": "diamandhälm□□uff'm kopp:□+ 3 rüsdung□+ 2 rüsdungshärde",
  "item.minecraft.diamond_chestplate": "diamandharnüsch□□am görborr:□+ 8 rüsdung□+ 2 rüsdungshärde",
  "item.minecraft.diamond_leggings": "diamandbeenschudds□□an d'n beenen:□+ 6 rüsdung□+ 2 rüsdungshärde",
  "item.minecraft.diamond_boots": "diamandlaadschn□□an den füßn:□+ 3 rüsdung□+ 2 rüsdungshärde",
  "item.minecraft.golden_helmet": "goldhälm□□uff'm kopp:□+ 2 rüsdung",
  "item.minecraft.golden_chestplate": "goldharnüsch□□am görborr:□+ 5 rüsdung",
  "item.minecraft.golden_leggings": "goldbeenschudds□□an d'n beenen:□+ 3 rüsdung",
  "item.minecraft.golden_boots": "goldlaadschn□□an den füßn:□+ 1 rüsdung",
  "item.minecraft.netherite_helmet": "nädderidhälm□□uff'm kopp:□+ 3 rüsdung□+ 3 rüsdungshärde□+ 1 schdandfesdischkeed",
  "item.minecraft.netherite_chestplate": "nädderidharnüsch□□am görborr:□+ 8 rüsdung□+ 3 rüsdungshärde□+ 1 schdandfesdischkeed",
  "item.minecraft.netherite_leggings": "nädderidbeenschudds□□an d'n beenen:□+ 6 rüsdung□+ 3 rüsdungshärde□+ 1 schdandfesdischkeed",
  "item.minecraft.netherite_boots": "nädderidlaadschn□□an den füßn:□+ 3 rüsdung□+ 3 rüsdungshärde□+ 1 schdandfesdischkeed",
  "item.minecraft.flint": "feuorrschdeen",
  "item.minecraft.porkchop": "rohes schweenefleesch",
  "item.minecraft.cooked_porkchop": "gebradnes schweenefleesch",
  "item.minecraft.painting": "gemäldä",
  "item.minecraft.golden_apple": "goldnorr abbl",
  "item.minecraft.enchanted_golden_apple": "vorzaubordorr goldnorr abbl",
  "block.minecraft.oak_sign": "eischnhulzschüld",
  "block.minecraft.spruce_sign": "fischdnhulzschüld",
  "block.minecraft.birch_sign": "bürschnhulzschüld",
  "block.minecraft.jungle_sign": "drobnhulzschüld",
  "block.minecraft.acacia_sign": "agazienhulzschüld",
  "block.minecraft.dark_oak_sign": "schworzeischnhulzschüld",
  "block.minecraft.crimson_sign": "garmesinschüld",
  "block.minecraft.warped_sign": "würrschüld",
  "item.minecraft.bucket": "ehmorr",
  "item.minecraft.water_bucket": "wassorrehmorr",
  "item.minecraft.lava_bucket": "lavaehmorr",
  "item.minecraft.minecart": "lore",
  "item.minecraft.saddle": "saddl",
  "item.minecraft.redstone": "redstone-schdoob",
  "item.minecraft.snowball": "schneeball",
  "item.minecraft.oak_boat": "eischnhulzbood",
  "item.minecraft.leather": "lädor",
  "item.minecraft.milk_bucket": "milschehmorr",
  "item.minecraft.pufferfish_bucket": "guchlfischehmorr",
  "item.minecraft.salmon_bucket": "lachsehmorr",
  "item.minecraft.cod_bucket": "gabljauehmorr",
  "item.minecraft.tropical_fish_bucket": "drobnfischehmorr",
  "item.minecraft.brick": "zieschl",
  "item.minecraft.clay_ball": "donglumbn",
  "block.minecraft.dried_kelp_block": "gedroggnedorr seedangblogg",
  "item.minecraft.paper": "babbiorr",
  "item.minecraft.book": "schwahrde",
  "item.minecraft.slime_ball": "schleimball",
  "item.minecraft.chest_minecart": "güdorlore",
  "item.minecraft.furnace_minecart": "andriebslore",
  "item.minecraft.egg": "ei",
  "item.minecraft.compass": "gombass",
  "item.minecraft.fishing_rod": "angl",
  "item.minecraft.clock": "uhr",
  "item.minecraft.glowstone_dust": "glowstoneschdaub",
  "item.minecraft.cod": "rohorr gabljau",
  "item.minecraft.salmon": "rohorr lachs",
  "item.minecraft.tropical_fish": "drobnfisch",
  "item.minecraft.pufferfish": "guchlfisch",
  "item.minecraft.cooked_cod": "gebradnorr gabljau",
  "item.minecraft.cooked_salmon": "gebradnorr lachs",
  "item.minecraft.ink_sac": "dindnbeudl",
  "item.minecraft.red_dye": "rodorr farbschdoff",
  "item.minecraft.green_dye": "grienorr farbschdoff",
  "item.minecraft.cocoa_beans": "gaggaubohn",
  "item.minecraft.lapis_lazuli": "labisladsuli",
  "item.minecraft.purple_dye": "lila farbschdoff",
  "item.minecraft.cyan_dye": "dürgisorr farbschdoff",
  "item.minecraft.light_gray_dye": "hellgrauorr farbschdoff",
  "item.minecraft.gray_dye": "grauorr farbschdoff",
  "item.minecraft.pink_dye": "pingorr farbschdoff",
  "item.minecraft.lime_dye": "hellgrienorr farbschdoff",
  "item.minecraft.yellow_dye": "gelborr farbschdoff",
  "item.minecraft.light_blue_dye": "hellblauorr farbschdoff",
  "item.minecraft.magenta_dye": "magenda farbschdoff",
  "item.minecraft.orange_dye": "orangschorr farbschdoff",
  "item.minecraft.bone_meal": "gnochnmehl",
  "item.minecraft.blue_dye": "blauorr farbschdoff",
  "item.minecraft.brown_dye": "braunorr farbschdoff",
  "item.minecraft.black_dye": "schworzorr farbschdoff",
  "item.minecraft.white_dye": "weeßorr farbschdoff",
  "item.minecraft.bone": "gnochn",
  "item.minecraft.sugar": "zuggorr",
  "block.minecraft.cake": "guchn",
  "block.minecraft.white_bed": "weeßes bädde",
  "block.minecraft.orange_bed": "orangsches bädde",
  "block.minecraft.magenta_bed": "magenda bädde",
  "block.minecraft.light_blue_bed": "hellblaues bädde",
  "block.minecraft.yellow_bed": "gelbes bädde",
  "block.minecraft.lime_bed": "hellgrienes bädde",
  "block.minecraft.pink_bed": "pinges bädde",
  "block.minecraft.gray_bed": "graues bädde",
  "block.minecraft.light_gray_bed": "hellgraues bädde",
  "block.minecraft.cyan_bed": "dürgises bädde",
  "block.minecraft.purple_bed": "lila bädde",
  "block.minecraft.blue_bed": "blaues bädde",
  "block.minecraft.brown_bed": "braunes bädde",
  "block.minecraft.green_bed": "grienes bädde",
  "block.minecraft.red_bed": "rodes bädde",
  "block.minecraft.black_bed": "schworzes bädde",
  "item.minecraft.cookie": "gehgs",
  "item.minecraft.filled_map": "garde□#0",
  "item.minecraft.shears": "schähre",
  "item.minecraft.melon_slice": "melonscheibe",
  "item.minecraft.dried_kelp": "gedroggnedorr seedang",
  "item.minecraft.pumpkin_seeds": "gürbisgerne",
  "item.minecraft.melon_seeds": "melongerne",
  "item.minecraft.beef": "rohes rindfleesch",
  "item.minecraft.cooked_beef": "schdeak",
  "item.minecraft.chicken": "rohes hühnschn",
  "item.minecraft.cooked_chicken": "gebradnes hühnschn",
  "item.minecraft.rotten_flesh": "vorrgammeldes fleesch",
  "item.minecraft.ender_pearl": "enderbärle",
  "item.minecraft.blaze_rod": "lohänrude",
  "item.minecraft.ghast_tear": "ghastdrähne",
  "item.minecraft.gold_nugget": "goldglumbn",
  "item.minecraft.nether_wart": "netherwarze",
  "item.minecraft.potion": "nisch braubarorr drang□keene effegde",
  "item.minecraft.glass_bottle": "glasbulle",
  "item.minecraft.spider_eye": "schbinnooche",
  "item.minecraft.fermented_spider_eye": "fermendierdes schbinnooche",
  "item.minecraft.blaze_powder": "lohänschdaub",
  "item.minecraft.magma_cream": "magmacreme",
  "block.minecraft.brewing_stand": "brauschdand",
  "block.minecraft.cauldron": "gessl",
  "item.minecraft.ender_eye": "enderooche",
  "item.minecraft.glistering_melon_slice": "glidzornde melonscheibe",
  "item.minecraft.bat_spawn_egg": "flädorrmaus-schborn-ei",
  "item.minecraft.bee_spawn_egg": "bien-schborn-ei",
  "item.minecraft.blaze_spawn_egg": "lohän-schborn-ei",
  "item.minecraft.cat_spawn_egg": "miedsekaddsn-schborn-ei",
  "item.minecraft.cave_spider_spawn_egg": "höhlnschbinn-schborn-ei",
  "item.minecraft.chicken_spawn_egg": "hühnschn-schborn-ei",
  "item.minecraft.cod_spawn_egg": "gabljau-schborn-ei",
  "item.minecraft.cow_spawn_egg": "guh-schborn-ei",
  "item.minecraft.creeper_spawn_egg": "creeper-schborn-ei",
  "item.minecraft.dolphin_spawn_egg": "delfin-schborn-ei",
  "item.minecraft.donkey_spawn_egg": "esl-schborn-ei",
  "item.minecraft.drowned_spawn_egg": "erdrungnen-schborn-ei",
  "item.minecraft.elder_guardian_spawn_egg": "großorr-wäschdorr-schborn-ei",
  "item.minecraft.enderman_spawn_egg": "enderman-schborn-ei",
  "item.minecraft.endermite_spawn_egg": "endermiten-schborn-ei",
  "item.minecraft.evoker_spawn_egg": "magiorr-schborn-ei",
  "item.minecraft.fox_spawn_egg": "fuggs-schborn-ei",
  "item.minecraft.ghast_spawn_egg": "ghast-schborn-ei",
  "item.minecraft.guardian_spawn_egg": "wäschdorr-schborn-ei",
  "item.minecraft.hoglin_spawn_egg": "hoglin-schborn-ei",
  "item.minecraft.horse_spawn_egg": "färde-schborn-ei",
  "item.minecraft.husk_spawn_egg": "wüsdnzombie-schborn-ei",
  "item.minecraft.llama_spawn_egg": "lama-schborn-ei",
  "item.minecraft.magma_cube_spawn_egg": "magmawürfl-schborn-ei",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom-schborn-ei",
  "item.minecraft.mule_spawn_egg": "mauldier-schborn-ei",
  "item.minecraft.ocelot_spawn_egg": "oddselod-schborn-ei",
  "item.minecraft.panda_spawn_egg": "panda-schborn-ei",
  "item.minecraft.parrot_spawn_egg": "babagein-schborn-ei",
  "item.minecraft.phantom_spawn_egg": "phandom-schborn-ei",
  "item.minecraft.pig_spawn_egg": "schweene-schborn-ei",
  "item.minecraft.piglin_spawn_egg": "piglin-schborn-ei",
  "item.minecraft.pillager_spawn_egg": "plündororr-schborn-ei",
  "item.minecraft.polar_bear_spawn_egg": "eisbärn-schborn-ei",
  "item.minecraft.pufferfish_spawn_egg": "guchlfisch-schborn-ei",
  "item.minecraft.rabbit_spawn_egg": "garniggl-schborn-ei",
  "item.minecraft.ravager_spawn_egg": "vorwüsdorr-schborn-ei",
  "item.minecraft.salmon_spawn_egg": "lachs-schborn-ei",
  "item.minecraft.sheep_spawn_egg": "schafs-schborn-ei",
  "item.minecraft.shulker_spawn_egg": "shulker-schborn-ei",
  "item.minecraft.silverfish_spawn_egg": "silborfischschn-schborn-ei",
  "item.minecraft.skeleton_spawn_egg": "schgeledd-schborn-ei",
  "item.minecraft.skeleton_horse_spawn_egg": "schgeleddfärd-schborn-ei",
  "item.minecraft.slime_spawn_egg": "schleim-schborn-ei",
  "item.minecraft.spider_spawn_egg": "schbinn-schborn-ei",
  "item.minecraft.squid_spawn_egg": "dindnfisch-schborn-ei",
  "item.minecraft.stray_spawn_egg": "eiswandororr-schborn-ei",
  "item.minecraft.strider_spawn_egg": "schreidorr-spawn-ei",
  "item.minecraft.trader_llama_spawn_egg": "händlorlama-schborn-ei",
  "item.minecraft.tropical_fish_spawn_egg": "drobnfisch-schborn-ei",
  "item.minecraft.turtle_spawn_egg": "schüldgrödn-schborn-ei",
  "item.minecraft.vex_spawn_egg": "blagegeisdorr-schborn-ei",
  "item.minecraft.villager_spawn_egg": "dorfbewohnorr-schborn-ei",
  "item.minecraft.vindicator_spawn_egg": "dienorr-schborn-ei",
  "item.minecraft.wandering_trader_spawn_egg": "fahrendorr-händlorr-schborn-ei",
  "item.minecraft.witch_spawn_egg": "heggsn-schborn-ei",
  "item.minecraft.wither_skeleton_spawn_egg": "witherschgeledd-schborn-ei",
  "item.minecraft.wolf_spawn_egg": "wulfs-schborn-ei",
  "item.minecraft.zoglin_spawn_egg": "zoglin-schborn-ei",
  "item.minecraft.zombie_spawn_egg": "zombie-schborn-ei",
  "item.minecraft.zombie_horse_spawn_egg": "zombiefärde-schborn-ei",
  "item.minecraft.zombie_villager_spawn_egg": "zombiedorfbewohnorr-schborn-ei",
  "item.minecraft.zombified_piglin_spawn_egg": "zombifizierdorr-piglin-schborn-ei",
  "item.minecraft.experience_bottle": "erfahrungsfläschschn",
  "item.minecraft.fire_charge": "feuorrguchl",
  "item.minecraft.writable_book": "schwahrde un fädorr",
  "item.minecraft.written_book": "beschriebne schwahrde",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "rahm",
  "block.minecraft.flower_pot": "bluhmdobb",
  "item.minecraft.carrot": "möhre",
  "item.minecraft.potato": "gardoffl",
  "item.minecraft.baked_potato": "ofngardoffl",
  "item.minecraft.poisonous_potato": "gifdsche gardoffl",
  "item.minecraft.map": "leere garde",
  "item.minecraft.golden_carrot": "guldne möhre",
  "block.minecraft.skeleton_skull": "schgeleddnischl",
  "block.minecraft.wither_skeleton_skull": "witherschgeleddnischl",
  "block.minecraft.player_head": "schbielorrnischl",
  "block.minecraft.zombie_head": "zombienischl",
  "block.minecraft.creeper_head": "creepernischl",
  "block.minecraft.dragon_head": "drachnnischl",
  "item.minecraft.carrot_on_a_stick": "möhrnrude",
  "item.minecraft.warped_fungus_on_a_stick": "würrbilzrude",
  "item.minecraft.nether_star": "netherschdern",
  "item.minecraft.pumpkin_pie": "gürbisguchn",
  "item.minecraft.firework_rocket": "feuorrwergsragede",
  "item.minecraft.firework_star": "feuorrwergsschdern",
  "item.minecraft.enchanted_book": "vorzauborde schwahrde",
  "item.minecraft.nether_brick": "netherzieschl",
  "item.minecraft.quartz": "netherquarz",
  "item.minecraft.tnt_minecart": "tnt-lore",
  "item.minecraft.hopper_minecart": "drischdorlore",
  "item.minecraft.prismarine_shard": "brismarinschärbe",
  "item.minecraft.prismarine_crystals": "brismaringrisdalle",
  "item.minecraft.rabbit": "rohes garniggl",
  "item.minecraft.cooked_rabbit": "gebradnes garniggl",
  "item.minecraft.rabbit_stew": "garnigglragout",
  "item.minecraft.rabbit_foot": "hasnpfode",
  "item.minecraft.rabbit_hide": "garnigglfell",
  "item.minecraft.armor_stand": "rüsdungsschdändorr",
  "item.minecraft.iron_horse_armor": "eisornorr rossharnüsch",
  "item.minecraft.golden_horse_armor": "goldnorr rossharnüsch",
  "item.minecraft.diamond_horse_armor": "diamandnorr rossharnüsch",
  "item.minecraft.leather_horse_armor": "lädornorr rossharnüsch",
  "item.minecraft.lead": "leene",
  "item.minecraft.name_tag": "namsschüld",
  "item.minecraft.command_block_minecart": "befählsblogglore",
  "item.minecraft.mutton": "rohes hammlfleesch",
  "item.minecraft.cooked_mutton": "gebradnes hammlfleesch",
  "block.minecraft.white_banner": "weeßes bannorr",
  "block.minecraft.orange_banner": "orangsches bannorr",
  "block.minecraft.magenta_banner": "magenda bannorr",
  "block.minecraft.light_blue_banner": "hellblaues bannorr",
  "block.minecraft.yellow_banner": "gelbes bannorr",
  "block.minecraft.lime_banner": "hellgrienes bannorr",
  "block.minecraft.pink_banner": "pinges bannorr",
  "block.minecraft.gray_banner": "graues bannorr",
  "block.minecraft.light_gray_banner": "hellgraues bannorr",
  "block.minecraft.cyan_banner": "dürgises bannorr",
  "block.minecraft.purple_banner": "lila bannorr",
  "block.minecraft.blue_banner": "blaues bannorr",
  "block.minecraft.brown_banner": "braunes bannorr",
  "block.minecraft.green_banner": "grienes bannorr",
  "block.minecraft.red_banner": "rodes bannorr",
  "block.minecraft.black_banner": "schworzes bannorr",
  "item.minecraft.end_crystal": "endergrisdall",
  "item.minecraft.chorus_fruit": "chorusfruchd",
  "item.minecraft.popped_chorus_fruit": "gebladdsde chorusfruchd",
  "item.minecraft.beetroot": "rode beede",
  "item.minecraft.beetroot_seeds": "rode-beede-samn",
  "item.minecraft.beetroot_soup": "borschdsch",
  "item.minecraft.dragon_breath": "drachnadem",
  "item.minecraft.splash_potion": "nisch braubarorr wurfdrang□keene effegde",
  "item.minecraft.spectral_arrow": "schbegdralpfeil",
  "item.minecraft.tipped_arrow": "nisch herschdellbarorr gedrängdorr pfeil□keene effegde",
  "item.minecraft.lingering_potion": "nisch braubarorr vorweildrang□keene effegde",
  "item.minecraft.shield": "schüld",
  "item.minecraft.elytra": "elydren",
  "item.minecraft.spruce_boat": "fischdnhulzbood",
  "item.minecraft.birch_boat": "bürschnhulzbood",
  "item.minecraft.jungle_boat": "drobnhulzbood",
  "item.minecraft.acacia_boat": "agazienhulzbood",
  "item.minecraft.dark_oak_boat": "schworzeischnhulzbood",
  "item.minecraft.totem_of_undying": "dodem dorr unschderblischkeed",
  "item.minecraft.shulker_shell": "shulker-schale",
  "item.minecraft.iron_nugget": "eisnglumbn",
  "item.minecraft.knowledge_book": "schwahrde des wissens",
  "item.minecraft.debug_stick": "debug-schdogg",
  "item.minecraft.music_disc_13": "schallbladde□c418 - 13",
  "item.minecraft.music_disc_cat": "schallbladde□c418 - cat",
  "item.minecraft.music_disc_blocks": "schallbladde□c418 - blocks",
  "item.minecraft.music_disc_chirp": "schallbladde□c418 - chirp",
  "item.minecraft.music_disc_far": "schallbladde□c418 - far",
  "item.minecraft.music_disc_mall": "schallbladde□c418 - mall",
  "item.minecraft.music_disc_mellohi": "schallbladde□c418 - mellohi",
  "item.minecraft.music_disc_stal": "schallbladde□c418 - stal",
  "item.minecraft.music_disc_strad": "schallbladde□c418 - strad",
  "item.minecraft.music_disc_ward": "schallbladde□c418 - ward",
  "item.minecraft.music_disc_11": "schallbladde□c418 - 11",
  "item.minecraft.music_disc_wait": "schallbladde□c418 - wait",
  "item.minecraft.music_disc_pigstep": "schallbladde□lena raine - pigstep",
  "item.minecraft.trident": "dreizagg□□in dorr haubdhand:□+ 8 angriffsschadn□-2.9 angriffsgeschwindischkeed",
  "item.minecraft.phantom_membrane": "phandomhaud",
  "item.minecraft.nautilus_shell": "naudilusschale",
  "item.minecraft.heart_of_the_sea": "härds des meeres",
  "item.minecraft.crossbow": "armbrusd",
  "item.minecraft.suspicious_stew": "susbeggde subbe",
  "block.minecraft.loom": "wäbbschduhl",
  "item.minecraft.flower_banner_pattern": "bannorrvorlaache□blume",
  "item.minecraft.creeper_banner_pattern": "bannorrvorlaache□creeper",
  "item.minecraft.skull_banner_pattern": "bannorrvorlaache□nischl",
  "item.minecraft.mojang_banner_pattern": "bannorrvorlaache□mojang-logo",
  "item.minecraft.globe_banner_pattern": "bannorrvorlaache□globus",
  "item.minecraft.piglin_banner_pattern": "bannorrvorlaache□gusche",
  "block.minecraft.composter": "gomboschdorr",
  "block.minecraft.barrel": "fass",
  "block.minecraft.smoker": "räuschoroofn",
  "block.minecraft.blast_furnace": "schmelzofn",
  "block.minecraft.cartography_table": "gardndisch",
  "block.minecraft.fletching_table": "bochnordisch",
  "block.minecraft.grindstone": "schleefschdeen",
  "block.minecraft.lectern": "lesebuld",
  "block.minecraft.smithing_table": "schmiededisch",
  "block.minecraft.stonecutter": "schdeensäsche",
  "block.minecraft.bell": "glogge",
  "block.minecraft.lantern": "ladderne",
  "block.minecraft.soul_lantern": "seelnladderne",
  "item.minecraft.sweet_berries": "süßbeern",
  "block.minecraft.campfire": "gnäggerchn",
  "block.minecraft.soul_campfire": "seelnlagorfeuorr",
  "block.minecraft.shroomlight": "bilzlischd",
  "item.minecraft.honeycomb": "honischwabe",
  "block.minecraft.bee_nest": "biennesd",
  "block.minecraft.beehive": "bienschdogg",
  "item.minecraft.honey_bottle": "honischbulle",
  "block.minecraft.honey_block": "honischblogg",
  "block.minecraft.honeycomb_block": "honischwabnblogg",
  "block.minecraft.lodestone": "leedschdeen",
  "block.minecraft.netherite_block": "nädderidblogg",
  "block.minecraft.ancient_debris": "andigorr schrodd",
  "block.minecraft.target": "zielblogg",
  "block.minecraft.crying_obsidian": "ninglndorr obsidian",
  "block.minecraft.blackstone": "schworzschdeen",
  "block.minecraft.blackstone_slab": "schworzschdeenschdufe",
  "block.minecraft.blackstone_stairs": "schworzschdeendrebbe",
  "block.minecraft.gilded_blackstone": "golddurschzochnorr schworzschdeen",
  "block.minecraft.polished_blackstone": "bolierdorr schworzschdeen",
  "block.minecraft.polished_blackstone_slab": "bolierde schworzschdeenschdufe",
  "block.minecraft.polished_blackstone_stairs": "bolierde schworzschdeendrebbe",
  "block.minecraft.chiseled_polished_blackstone": "gemeißeldorr bolierdorr schworzschdeen",
  "block.minecraft.polished_blackstone_bricks": "bolierde schworzschdeenzieschl",
  "block.minecraft.polished_blackstone_brick_slab": "bolierde schworzschdeenzieschlschdufe",
  "block.minecraft.polished_blackstone_brick_stairs": "bolierde schworzschdeenzieschldrebbe",
  "block.minecraft.cracked_polished_blackstone_bricks": "riss'sche bolierde schworzschdeenzieschl",
  "block.minecraft.respawn_anchor": "seelnangorr",
}
export const sxu = items; 
